import cmmnRoutes from "@/router/items/CmmnRoutes";
import centerIntro from "@/router/client/CenterIntroRoutes"; // 센터소개
import majorFree from "@/router/client/MajorFreeRouter"; // 전공자율선택제
import ecpIntro from "@/router/client/EcpIntroRouter"; // 비교과제도
import board from "@/router/client/BoardRoutes"; // 게시판

const clientRoutes = [
  {
    path: "",
    name: "client",
    redirect: "/main",
    component: () => import("@/layout/LayoutClient.vue"),
    children: [
      {
        path: "main",
        component: () => import("@/views/main/UserMainIndex.vue"),
        menuCd: "MAIN",
      },
      ...centerIntro, // 센터소개
      ...majorFree, // 전공자율선택제
      ...ecpIntro, // 비교과제도
      ...board, // 게시판
    ],
  },
  ...cmmnRoutes, // 공통 라우트
];

export default clientRoutes;
